import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { ReverseButtonContainer } from '../styles';
import { ButtonLabel } from '../shared';
var ReverseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      dataTest = _ref['data-test'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      buttonProps = _objectWithoutProperties(_ref, ["children", "size", "isLoading", "loadingText", "data-test", "type"]);

  return /*#__PURE__*/React.createElement(ReverseButtonContainer, _extends({}, buttonProps, {
    "data-test": dataTest ? dataTest : undefined,
    size: size,
    isLoading: isLoading,
    ref: ref,
    type: type
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    isLoading: isLoading,
    size: size,
    loadingText: loadingText
  }, children));
});
ReverseButton.displayName = 'ReverseButton';
export default ReverseButton;